import { parsePhoneNumber } from 'libphonenumber-js';
import { _ } from '/@/locale';

const formatPhoneWithCountryCode = (phone: string) => {
    const cleanPhone = phone.replace(/[^\d+]/g, '');
    if (cleanPhone.startsWith('+52') || cleanPhone.startsWith('52')) {
        const withoutPrefix = cleanPhone.replace(/^\+?52/, '');
        if (withoutPrefix.startsWith('1')) {
            return `+52${withoutPrefix.slice(1)}`;
        }
    }
    return cleanPhone.startsWith('+') ? cleanPhone : `+${cleanPhone}`;
};

const parseAndValidatePhoneNumber = (formattedPhone: string) => {
    try {
        const parsedNumber = parsePhoneNumber(formattedPhone);
        return parsedNumber && parsedNumber.isValid() ? parsedNumber : null;
    } catch {
        return null;
    }
};

export const validatePhoneNumber = (phone: string) => {
    const formattedPhone = formatPhoneWithCountryCode(phone);
    return !!parseAndValidatePhoneNumber(formattedPhone);
};

export const formatPhoneNumber = (phone: string) => {
    const formattedPhone = formatPhoneWithCountryCode(phone);
    const parsedNumber = parseAndValidatePhoneNumber(formattedPhone);
    if (!parsedNumber) throw new Error(_('El formato del número de teléfono es incorrecto.'));
    return parsedNumber.format('E.164');
};
